import * as React from 'react'

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isExpanded: boolean
  overflowCount?: number
  onClick: (event: React.SyntheticEvent) => void
}

const ICON_SIZE = 16

const ChipMoreButton: React.FC<IProps> = ({
  isExpanded,
  overflowCount,
  onClick,
}) => {
  return (
    <div
      className="inline-block h20 brada2 bg-neutral-92 my2 mr4 pointer"
      onClick={onClick}
      title={
        isExpanded
          ? Localization.translator.showLess
          : `+${overflowCount} ${Localization.translator.more}`
      }
    >
      <span className="px5">
        {isExpanded ? (
          <ChevronUpIcon size={ICON_SIZE} className="tw:align-middle" />
        ) : (
          <ChevronDownIcon size={ICON_SIZE} className="tw:align-middle" />
        )}
      </span>
      <span className="text large line-extra-large no-flex pr8">
        {isExpanded
          ? Localization.translator.showLess
          : `+${overflowCount} ${Localization.translator.more}`}
      </span>
    </div>
  )
}

export default observer(ChipMoreButton)
